import { gql } from '__generated__';

export default gql(`
  query GetRegistrations(
    $project_id: ID!,
    $page: Int,
    $per_page: Int,
    $events: [ID!],
    $search: String,
    $min_age: Int,
    $max_age: Int,
    $genders: [Gender!],
    $tickets: [ID!],
    $ticket_categories: [ID!],
    $time_slots: [ID!],
    $products: [ID!],
    $product_variants: [ID!],
    $promotions: [ID!],
    $invitations: [ID!],
    $coupons: [ID!],
    $lotteries: [ID!],
    $rejected_lotteries: [ID!],
    $created_after: String,
    $created_before: String,
    $statuses: [PurchaseStatus!],
    $assignment_statuses: [AssignmentStatus!],
    $resale_statuses: [RegistrationResaleStatus!],
    $payment_statuses: [PurchasePaymentStatus!],
    $participant_fields: [ParticipantFieldFilter!],
    $participant_field_choices: [ID!],
    $ticket_number_sequences: [ID!],
    $has_ticket_number: Boolean,
    $has_team: Boolean,
    $active: Boolean,
    $participant_filters: ParticipantFilters,
  ) {
    project(id: $project_id) {
      id
      events {
        total
      }
      registrations(
        page: $page,
        per_page: $per_page,
        events: $events,
        search: $search,
        min_age: $min_age,
        max_age: $max_age,
        genders: $genders,
        tickets: $tickets,
        ticket_categories: $ticket_categories,
        time_slots: $time_slots,
        products: $products,
        product_variants: $product_variants,
        promotions: $promotions,
        invitations: $invitations,
        coupons: $coupons,
        lotteries: $lotteries,
        rejected_lotteries: $rejected_lotteries,
        created_after: $created_after,
        created_before: $created_before,
        statuses: $statuses,
        assignment_statuses: $assignment_statuses,
        resale_statuses: $resale_statuses,
        payment_statuses: $payment_statuses,
        participant_fields: $participant_fields,
        participant_field_choices: $participant_field_choices,
        ticket_number_sequences: $ticket_number_sequences,
        has_ticket_number: $has_ticket_number,
        has_team: $has_team,
        active: $active,
        participant_filters: $participant_filters,
      ) {
        data {
          id
          sequence
          assigned
          invited_email
          full_name
          ticket_number
          status
          created_at
          ticket {
            id
            title
          }
          time_slot {
            id
            start_date
            start_time
            multi_date
          }
          event {
            id
            title
          }
          purchase {
            id
            active
          }
          participant {
            id
            email
          }
        }
        current_page
        per_page
        has_more_pages
      }
    }
  }
`);
